const ptBrPercentFormatter = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
});

export function getPriceChange(previousCents: number, currentCents: number) {
    const percent = ((currentCents - previousCents) / previousCents) * 100;
    const rounded = percent.toFixed(0);

    const sign = percent > 0 ? '+' : '';
    const formattedPtBrValue = Number.isFinite(percent)
        ? ptBrPercentFormatter.format(percent)
        : rounded;

    return {
        percent: Number(rounded),
        formatted: `${sign}${rounded}%`,
        isIncrease: percent > 0,
        formattedPtBr: `${sign}${formattedPtBrValue}%`,
    };
}
